export const isNull = (value) => {
    return value === '' || value === undefined || value === null;
}

export const isEmpty = (array) => array.length === 0;